import { useState } from 'react';
import {
	useGetActivities,
	useGetFavoriteActivities,
	useSetFavoriteActivity,
} from '../../../Core/Hooks/useTimereport';
import { TimereportActivity } from '../../../Core/Types/admin/timereport';
import './TimereportActivitySelector.scss';

type TimereportActivitySelectorProps = {
	selectedProjectId: number;
	selectedActivityId: number;
	onSelect: (projectId: number, activityId: number, typeId: number) => void;
};

const TimereportActivitySelector = ({
	selectedProjectId,
	selectedActivityId,
	onSelect,
}: TimereportActivitySelectorProps) => {
	const { activities } = useGetActivities();
	const { favorites } = useGetFavoriteActivities();
	const { toggleFavorite } = useSetFavoriteActivity();
	const [showBrowser, setShowBrowser] = useState(false);

	const handleSelectActivity = (activity: TimereportActivity) => {
		const defaultTypeId = activity.timereportTypes.length > 0 ? activity.timereportTypes[0].timereportTypeId : 0;
		onSelect(activity.projectId, activity.id, defaultTypeId);
		setShowBrowser(false);
	};

	const handleToggleFavorite = (e: React.MouseEvent, activity: TimereportActivity) => {
		e.stopPropagation();
		toggleFavorite(activity.projectId, activity.id, !activity.isFavorite);
	};

	const isSelected = (activity: TimereportActivity) =>
		activity.projectId === selectedProjectId && activity.id === selectedActivityId;

	return (
		<div className='biz-timereport-activity-selector'>
			{favorites && favorites.length > 0 && (
				<div className='biz-timereport-activity-selector__favorites'>
					{favorites.map((fav) => (
						<div
							key={`${fav.projectId}-${fav.id}`}
							className={`biz-timereport-activity-selector__favorite-chip${isSelected(fav) ? ' biz-timereport-activity-selector__favorite-chip--selected' : ''}`}
							onClick={() => handleSelectActivity(fav)}
						>
							{fav.projectName} / {fav.name}
							<span
								className='biz-timereport-activity-selector__star'
								onClick={(e) => handleToggleFavorite(e, fav)}
							>
								★
							</span>
						</div>
					))}
				</div>
			)}

			<div className='biz-timereport-activity-selector__browse'>
				<span
					className='biz-timereport-activity-selector__label'
					onClick={() => setShowBrowser(!showBrowser)}
					style={{ cursor: 'pointer' }}
				>
					{showBrowser ? '▾ Browse All Activities' : '▸ Browse All Activities'}
				</span>

				{showBrowser && activities && (
					<div className='biz-timereport-activity-selector__activity-list'>
						{activities.map((activity) => (
							<div
								key={`${activity.projectId}-${activity.id}`}
								className={`biz-timereport-activity-selector__activity-item${isSelected(activity) ? ' biz-timereport-activity-selector__activity-item--selected' : ''}`}
								onClick={() => handleSelectActivity(activity)}
							>
								<span className='biz-timereport-activity-selector__activity-name'>
									{activity.name}
								</span>
								<span className='biz-timereport-activity-selector__activity-project'>
									{activity.projectName}
								</span>
								<span
									className='biz-timereport-activity-selector__star'
									onClick={(e) => handleToggleFavorite(e, activity)}
								>
									{activity.isFavorite ? '★' : '☆'}
								</span>
							</div>
						))}
					</div>
				)}
			</div>
		</div>
	);
};

export default TimereportActivitySelector;
